import { implementationProvider } from '@printdeal/configuration';
import CustomerCareDropdown from './components/error-handling/CustomerCareDropdown';
import { SentryHelper } from './helpers/SentryHelper';

implementationProvider.provideSentryHelper(SentryHelper);

implementationProvider.provideCustomerCareComponent(CustomerCareDropdown);
